// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-family: var(--font-tusker);
  font-size: 26px;
  color: var(--ion-color-secondary);
  padding: 0px 0px 20px;
  margin-bottom: 0;
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 1px !important;
  --background: transparent;
  border: none;
}
ion-item ion-input {
  font-family: AppFont, san-serif;
  background: transparent;
}

ion-label {
  padding: 0px 5px;
}

.forgot-password {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.forgot-password h3 {
  color: var(--ion-color-secondary);
  font-family: AppFontBold;
  font-size: 14px;
  text-transform: none;
  padding: 15px 0px 48px;
}

.wrapper {
  padding: 25px;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

ion-button {
  font-family: AppFont, san-serif;
}

.sign_in-button {
  z-index: 10;
  text-transform: capitalize;
  --background: url('button_background_red.png') no-repeat center center/ 100% 100%;
}
@media (min-width: 991px) {
  .sign_in-button {
    --background: url('button_background_red_color.png') no-repeat center center/ 100% 100%;
  }
}

.sign_up-button {
  text-transform: capitalize;
  z-index: 10;
  --background: url('background-button.png') no-repeat center center/ 100% 100%;
}
@media (min-width: 991px) {
  .sign_up-button {
    --background: url('button_background_orange.png') no-repeat center center/ 100% 100%;
  }
}

.bottom-img {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.bottom-img ion-img {
  width: 100px;
}
@media (min-width: 991px) {
  .bottom-img ion-img {
    width: 200px;
  }
}
@media only screen and (min-device-width: 390px) and (max-device-width: 420px) {
  .bottom-img {
    /* For portrait layouts only */
  }
  .bottom-img ion-img {
    width: 120px;
  }
}
@media only screen and (min-device-width: 420px) and (max-device-width: 1000px) {
  .bottom-img {
    /* For portrait layouts only */
  }
  .bottom-img ion-img {
    width: 150px;
  }
}
.bottom-img .left {
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.bottom-img .right {
  position: absolute;
  bottom: 20px;
  right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-in/sign-in.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACE,+BAAA;EACA,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;AAFF;;AAOA;EACE,6BAAA;AAJF;;AAMA;EACE,8BAAA;EACA,yBAAA;EACA,YAAA;AAHF;AAIE;EACE,+BAAA;EACA,uBAAA;AAFJ;;AAMA;EAEE,gBAAA;AAJF;;AAMA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;AAHF;AAKE;EACE,iCAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;AAHJ;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AAJF;;AAOA;EACE,eAAA;EACA,mBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAOA;EACE,WAAA;EAEA,0BAAA;EACA,iFAAA;AALF;ACnEE;EDoEF;IAMI,uFAAA;EAHF;AACF;;AAOA;EACE,0BAAA;EACA,WAAA;EACA,6EAAA;AAJF;AC9EE;ED+EF;IAKI,oFAAA;EAFF;AACF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAFF;AAGE;EAIE,YAAA;AAJJ;AC7FE;ED6FA;IAEI,YAAA;EAEJ;AACF;AACE;EAXF;IAYI,8BAAA;EAEF;EADE;IACE,YAAA;EAGJ;AACF;AADE;EAjBF;IAkBI,8BAAA;EAIF;EAHE;IACE,YAAA;EAKJ;AACF;AAHE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAKJ;AAHE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AAKJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n\n.title {\n  font-family: var(--font-tusker);\n  font-size: 26px;\n  color: var(--ion-color-secondary);\n  padding: 0px 0px 20px;\n  margin-bottom: 0;\n}\n\n\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\nion-item {\n  --border-width: 1px !important;\n  --background: transparent;\n  border: none;\n  ion-input {\n    font-family: AppFont, san-serif;\n    background: transparent;\n  }\n}\n\nion-label {\n  // background: white;\n  padding: 0px 5px;\n}\n.forgot-password {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n\n  h3 {\n    color: var(--ion-color-secondary);\n    font-family: AppFontBold;\n    font-size: 14px;\n    text-transform: none;\n    padding: 15px 0px 48px;\n\n  }\n}\n.wrapper {\n  padding: 25px;\n}\n\n.stacked {\n  position: relative;\n  z-index: 2;\n  left: 20px;\n  top: 7px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  margin-bottom: 0;\n}\n\nion-button {\n  font-family: AppFont, san-serif;\n}\n\n.sign_in-button {\n  z-index: 10;\n\n  text-transform: capitalize;\n  --background: url(../../../assets/tabilo/button_background_red.png) no-repeat center center/ 100% 100%;\n  @include desktop {\n    --background: url(../../../assets/tabilo/button_background_red_color.png) no-repeat center center/ 100% 100%;\n\n  }\n}\n\n.sign_up-button {\n  text-transform: capitalize;\n  z-index: 10;\n  --background: url(../../../assets/tabilo/background-button.png) no-repeat center center/ 100% 100%;;\n  @include desktop {\n    --background: url(../../../assets/tabilo/button_background_orange.png) no-repeat center center/ 100% 100%;\n\n  }\n}\n.bottom-img {\n  position:absolute;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  ion-img {\n    @include desktop {\n      width: 200px;\n    }\n    width: 100px;\n  }\n  @media only screen and (min-device-width: 390px) and (max-device-width: 420px) {\n    /* For portrait layouts only */\n    ion-img {\n      width: 120px;\n    }\n  }\n  @media only screen and (min-device-width: 420px) and (max-device-width: 1000px) {\n    /* For portrait layouts only */\n    ion-img {\n      width: 150px;\n    }\n  }\n  .left {\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n  }\n  .right {\n    position: absolute;\n    bottom: 20px;\n    right: 0px;\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
